module.exports = __webpack_public_path__ + "static/PinnacleBadge_BoW_PinBadge-d7233fb434a46e6d23c86176ffb72ae7.png";